import { useUIStore } from '@/config/stores/ui-store';
import {
  ConversationAside,
  ConversationDrawer,
  ConversationNavbar,
  MemberAddDialog,
  MessageSearchDrawer
} from '@/features/conversation';
import { MessageList } from '@/features/message-list';
import { MessageInput, MessageListPinned } from '@/features/messages';
import { MessageForwardDialog } from '@/features/messages/components/message-forward-dialog';
import { useGetFriendsWithPresence } from '@/features/participant';
import { Box, Card } from '@mui/material';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../hooks/use-layout';

export const Widget = () => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const { sidebarExpanded, isMobile, toggleSidebar } = useLayout();
  const { activeConversation, toggleAside } = useUIStore();

  // Load friends with presence on component mount
  useGetFriendsWithPresence();

  return (
    <Card
      variant='outlined'
      ref={containerRef}
      sx={{
        position: 'relative',
        display: 'flex',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        bgcolor: 'background.paper'
      }}
    >
      <ConversationDrawer open={sidebarExpanded} onClose={toggleSidebar} container={containerRef.current} />
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          backgroundColor: 'background.default',
          transition: 'opacity 300ms ease',
          opacity: { xs: isMobile && sidebarExpanded ? 0.5 : 1, md: 1 }
        }}
      >
        <ConversationNavbar conv={activeConversation} onMenuClick={toggleSidebar} showMenuButton={isMobile} />
        {activeConversation?.conversationId && <MessageListPinned conversationId={activeConversation.conversationId} />}
        <MessageList conversationId={activeConversation?.conversationId || ''} />
        <MessageInput
          convId={activeConversation?.conversationId || null}
          placeholder={t('layout.chatInput.placeholder')}
          disabled={!activeConversation}
        />
      </Box>
      <ConversationAside onClose={toggleAside} container={containerRef.current} />
      <MemberAddDialog />
      <MessageForwardDialog conversationId={activeConversation?.conversationId || ''} />
      <MessageSearchDrawer conversationId={activeConversation?.conversationId} />
    </Card>
  );
};
